// src/utils/AuthHelper.js

let logoutFn = null;

/**
 * Registra la función logout del AuthContext
 */
export const setLogoutFunction = (fn) => {
  logoutFn = fn;
};

/**
 * Llama al logout registrado desde cualquier parte
 */
export const triggerLogout = () => {
  if (logoutFn) {
    logoutFn();
  } else {
    console.warn("⚠️ No logout function registered in AuthHelper");
  }
};
